import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const API_URL = process.env.REACT_APP_API_URL || 'https://itil.tier5.com.ar/api';

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (user) navigate('/'); }, [user, navigate]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const jwt = params.get('jwt');
    const userData = params.get('user');
    const err = params.get('error');
    if (jwt && userData) {
      window.history.replaceState({}, '', '/login');
      try {
        login(jwt, JSON.parse(decodeURIComponent(userData)));
        navigate('/');
      } catch { setError('Error procesando credenciales.'); }
      return;
    }
    if (err) {
      window.history.replaceState({}, '', '/login');
      const msgs = {
        not_registered: 'Tu cuenta no está registrada.',
        disabled: 'Tu cuenta está desactivada.',
        no_access: 'No tenés permisos para acceder al panel de administración.',
        auth_failed: 'Error de autenticación.',
      };
      setError(msgs[err] || 'Error de acceso.');
    }
  }, []);

  const handleGoogleLogin = async () => {
    setLoading(true);
    setError('');
    try {
      const r = await fetch(`${API_URL}/verify/oauth/url?returnTo=admin`);
      const data = await r.json();
      window.location.href = data.url;
    } catch {
      setError('Error conectando con Google.');
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#0A1628', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div style={{ background: '#fff', borderRadius: 12, padding: '40px', width: '100%', maxWidth: 400, boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 32 }}>
          <div style={{ width: 44, height: 44, background: '#0063A5', borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 700, fontSize: 16 }}>IT</div>
          <div>
            <div style={{ fontSize: 16, fontWeight: 700, color: '#1a1a1a' }}>ITIL Suite</div>
            <div style={{ fontSize: 12, color: '#888' }}>Panel de administración</div>
          </div>
        </div>

        <div style={{ fontSize: 22, fontWeight: 600, marginBottom: 6, color: '#1a1a1a' }}>Acceso restringido</div>
        <div style={{ fontSize: 13, color: '#666', marginBottom: 28, lineHeight: 1.5 }}>Solo para administradores de tier5.com.ar</div>

        {error && (
          <div style={{ background: '#FDECEB', border: '1px solid #F5C0BC', borderRadius: 8, padding: '12px 14px', fontSize: 13, color: '#C0392B', marginBottom: 20 }}>
            {error}
          </div>
        )}

        <button onClick={handleGoogleLogin} disabled={loading} style={{
          width: '100%', padding: '12px 16px', background: '#fff', color: '#444',
          border: '1.5px solid #ddd', borderRadius: 8, fontSize: 14, fontWeight: 500,
          cursor: loading ? 'not-allowed' : 'pointer',
          display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10,
          opacity: loading ? 0.7 : 1,
        }}>
          {loading ? 'Conectando...' : (
            <>
              <svg width="18" height="18" viewBox="0 0 48 48">
                <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
                <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
                <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
                <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.18 1.48-4.97 2.31-8.16 2.31-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
              </svg>
              Continuar con Google
            </>
          )}
        </button>

        <p style={{ textAlign: 'center', fontSize: 11, color: '#bbb', marginTop: 20 }}>
          Solo cuentas @tier5.com.ar con permisos de superadmin
        </p>
      </div>
    </div>
  );
}
